import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import Modal from '../components/Modal';

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [modalConfig, setModalConfig] = useState(null);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      const config = typeof options === 'string'
        ? { message: options }
        : options;

      setModalConfig({
        isOpen: true,
        title: config.title || 'Confirm Action',
        message: config.message || '',
        variant: config.variant || 'warning',
        confirmText: config.confirmText || 'Confirm',
        cancelText: config.cancelText || 'Cancel',
        showCancel: config.showCancel !== false,
        onConfirm: () => {
          setModalConfig(null);
          resolve(true);
        },
        onCancel: () => {
          setModalConfig(null);
          resolve(false);
        }
      });
    });
  }, []);

  const alert = useCallback((options) => {
    return new Promise((resolve) => {
      const config = typeof options === 'string'
        ? { message: options }
        : options;

      setModalConfig({
        isOpen: true,
        title: config.title || (config.variant === 'danger' ? 'Error' : 'Notice'),
        message: config.message || '',
        variant: config.variant || 'info',
        confirmText: config.confirmText || 'OK',
        showCancel: false,
        onConfirm: () => {
          setModalConfig(null);
          resolve(true);
        },
        onCancel: () => {
          setModalConfig(null);
          resolve(true);
        }
      });
    });
  }, []);

  const value = useMemo(() => ({ confirm, alert }), [confirm, alert]);

  return (
    <ModalContext.Provider value={value}>
      {children}
      {modalConfig && <Modal {...modalConfig} />}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
